import { useMutationClubDetails, useQueryClubDetails } from "@gymflow/api";
import { createColumnHelper } from "@tanstack/react-table";
import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ApiResolverContext } from "../../../providers/ApiResolverProvider/ApiResolverContext";
import useGymflowModels from "../../../store";
import { Switch } from "../../atoms";
import { PaginatedTable } from "../../organisms";

export const PaymentMethodsTabOnline = () => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);
  const { data: club, isLoading } = useQueryClubDetails({
    api,
    clubId: clubId,
  });
  const { mutateAsync: clubDetailsMutateAsync } = useMutationClubDetails({
    api,
  });
  const data = useMemo(
    () => [
      {
        name: t("pages.settings.tab.paymentMethods.creditDebitCards"),
        active: true,
        disabled: true,
      },
      {
        name: t("pages.settings.tab.paymentMethods.bankDebits").toString(),
        active: !!club?.directDebitEnabled,
        disabled: club?.stripeAccountType !== "CONNECTED",
      },
    ],
    [club?.directDebitEnabled, club?.stripeAccountType, t],
  );
  const columns = useMemo(() => {
    const columnHelper = createColumnHelper<(typeof data)[number]>();
    return [
      columnHelper.accessor("name", {
        header: t("portal.common.name").toString(),
        cell: ({ getValue }) => {
          return <div>{getValue()}</div>;
        },
      }),
      columnHelper.display({
        id: "active",
        header: t("portal.common.active"),
        cell: ({ row }) => {
          const value = row.original;
          return (
            <Switch
              key={value.name}
              disabled={value.disabled}
              value={value.active}
              onChange={async (checked) => {
                await clubDetailsMutateAsync({
                  clubId: clubId,
                  payload: { directDebitEnabled: checked },
                });
              }}
            />
          );
        },
      }),
    ];
  }, [clubDetailsMutateAsync, clubId, t]);

  return (
    <PaginatedTable
      tableProps={{
        data,
        columns,
        isFetching: isLoading,
      }}
    />
  );
};
